// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__TPWtq","logosContainer":"styles_logosContainer__oaAUw"};